import React from 'react';
import { useFormikContext } from 'formik';
import { Typography, Grid, Divider } from '@mui/material';
import ResourceDetails from './ResourceDetails';
import PaymentDetails from './PaymentDetails';
import PersonDetails from './PersonDetails';

export default function ReviewData() {
  const { values: formValues } = useFormikContext();
  return (
    <React.Fragment>
      <Typography variant="h4">
        Revise sus datos
      </Typography>
      <Grid container>
        <ResourceDetails formValues={formValues} />
      </Grid>
      <Divider variant="fullWidth" />
      <Grid container>
        <PersonDetails formValues={formValues} />
        <Divider variant="middle" orientation="vertical" flexItem />
        <PaymentDetails formValues={formValues} />
      </Grid>
      <Divider variant="fullWidth" />
    </React.Fragment>
  );
}